import { Edit } from 'react-admin';
import { TargetForm } from './Target.Form';

export const TargetEdit = () => {
    return (
        <Edit>
            <TargetForm />
        </Edit>
    );
};
